import { lazyImport } from '@/utils/lazyImport';

const { LoginRoutes } = lazyImport(() => import(`@/features/login`), `LoginRoutes`);

export const publicRoutes = [
  {
    path: `/login/*`,
    element: <LoginRoutes />,
  },
];
